import React from 'react';
const ErrorReportingTestPage = () => {
  const foo: any = {};
  // eslint-disable-next-line
  return <div>{foo.bar.baz}</div>;
};

export default ErrorReportingTestPage;
